import { render, staticRenderFns } from "./acupointDialog.vue?vue&type=template&id=0b897891&scoped=true"
import script from "./acupointDialog.vue?vue&type=script&lang=js"
export * from "./acupointDialog.vue?vue&type=script&lang=js"
import style0 from "./acupointDialog.vue?vue&type=style&index=0&id=0b897891&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b897891",
  null
  
)

export default component.exports